@if (isLoading) {
  <app-loading-spinner [message]="'Loading order details'"></app-loading-spinner>
} @else {
  @if (order) {
    <div class="container-fluid">
      <div class="col-12 px-0 mb-4">
        <div class="card p-0 border-0">
          <div class="card-body p-3">
            <div class="d-flex justify-content-between align-items-center mb-4 pb-3 border-bottom">
              <div class="d-flex align-items-center gap-3">
                <i class="card-title bi bi-arrow-left me-2 cursor-pointer" (click)="goBack()"></i>
                <div>
                  <h5 class="mb-0 fw-bold">Order #{{ order.order_number }}</h5>
                  <span class="text-muted">{{ order.created_at | date: 'mediumDate' }}</span>
                </div>
              </div>

              @if (order.invoice_status === 'generated') {
                <button class="btn btn-enjochem btn-primary" (click)="downloadInvoice()">
                  <i class="bi bi-download"></i>
                  Download Invoice
                </button>
              } @else {
                <div class="alert alert-info py-2 px-3 mb-0 small d-flex align-items-center">
                  <app-loading-spinner [inline]="true" class="me-2"></app-loading-spinner>
                  Invoice is generating. Please wait some time.
                </div>
              }
            </div>

            <div class="row g-4">
              <div class="col-lg-3 col-md-6">
                <div class="d-flex align-items-start gap-3">
                  <div class="flex-grow-1">
                    <span>Customer / Dealer</span>
                    <div class="mt-1">{{ order.dealer.shop_name }}</div>
                    <span class="text-muted">{{ order.dealer.first_name }} {{ order.dealer.last_name }}</span>
                  </div>
                </div>
              </div>

              @if (order.employee) {
                <div class="col-lg-3 col-md-6">
                  <div class="d-flex align-items-start gap-3">
                    <div class="flex-grow-1">
                      <span>Employee</span>
                      <div class="mt-1">{{ order.employee.full_name }}</div>
                      <span class="text-muted">{{ order.employee.employee_number }}</span>
                    </div>
                  </div>
                </div>
              }

              <div class="col-lg-3 col-md-6">
                <div class="d-flex align-items-start gap-3">
                  <div class="flex-grow-1">
                    <span>Delivery address</span>
                    <div class="mt-1">{{ order.delivery_address }}</div>
                  </div>
                </div>
              </div>

              <div class="col-lg-3 col-md-6">
                <div class="d-flex align-items-start gap-3">
                  <div class="flex-grow-1">
                    <span>Order Date</span>
                    <div class="mt-1">{{ order.created_at | date: 'dd MMM yyyy' }}</div>
                  </div>
                </div>
              </div>

              <div class="col-lg-3 col-md-6">
                <div class="d-flex align-items-start gap-3">
                  <div class="flex-grow-1">
                    <span>Dispatch requested date</span>
                    <div class="mt-1">{{ order.dispatch_requested_date }}</div>
                  </div>
                </div>
              </div>

              <div class="col-lg-3 col-md-6">
                <div class="d-flex align-items-start gap-3">
                  <div class="flex-grow-1">
                    <span>Order Type</span>
                    <div class="mt-1">
                      {{ OrderTypeTexts[order.order_type] || '-' }}
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-lg-3 col-md-6">
                <div class="d-flex align-items-start gap-3">
                  <div class="flex-grow-1">
                    <span>Preferred Transport</span>
                    <div class="mt-1">{{ order.preferred_transport }}</div>
                  </div>
                </div>
              </div>

              @if (order.company) {
                <div class="col-lg-3 col-md-6">
                  <div class="d-flex align-items-start gap-3">
                    <div class="flex-grow-1">
                      <span>Company</span>
                      <div class="mt-1">{{ order.company.name }}</div>
                    </div>
                  </div>
                </div>
              }

              <div class="col-lg-3 col-md-6">
                <div class="d-flex align-items-start gap-3">
                  <div class="flex-grow-1">
                    <span>Remarks</span>
                    <div class="mt-1">{{ order.remarks }}</div>
                  </div>
                </div>
              </div>

              <div class="col-lg-3 col-md-6">
                <div class="d-flex align-items-start gap-3">
                  <div class="flex-grow-1">
                    <span>Order Status</span>
                    <div class="mt-1">
                      <span
                        class="app-badge"
                        [class.badge-danger]="order.is_order_cancelled"
                        [class.badge-success]="!order.is_order_cancelled && order.is_fully_delivered"
                        [class.badge-warning]="
                          !order.is_order_cancelled &&
                          !order.is_fully_delivered &&
                          (order.is_partially_delivered || order.is_partially_shipped)
                        "
                        [class.badge-primary]="
                          !order.is_order_cancelled &&
                          !order.is_fully_delivered &&
                          !order.is_partially_delivered &&
                          order.is_fully_shipped &&
                          !order.is_partially_shipped
                        "
                        [class.badge-secondary]="
                          !order.is_order_cancelled &&
                          !order.is_fully_delivered &&
                          !order.is_partially_delivered &&
                          !order.is_fully_shipped &&
                          !order.is_partially_shipped
                        ">
                        {{
                          order.is_order_cancelled
                            ? 'Cancelled'
                            : order.is_fully_delivered
                              ? 'Delivered'
                              : order.is_partially_delivered
                                ? 'Partially Delivered'
                                : order.is_fully_shipped
                                  ? 'Fully Shipped'
                                  : order.is_partially_shipped
                                    ? 'Partially Shipped'
                                    : 'Pending'
                        }}
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Total Quantity -->
              <div class="col-lg-3 col-md-6">
                <div class="d-flex align-items-start gap-3">
                  <div class="flex-grow-1">
                    <span>Total Quantity</span>
                    <div class="fw-bold mt-1">
                      {{ order.total_boxes_ordered }}
                      <span class="text-muted fw-normal">Boxes</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-12 px-0 mb-4">
        <div class="card p-0 border-0">
          <div class="card-body p-3">
            <h6 class="fw-bold mb-4">Order Summary</h6>

            <div class="row g-3">
              <!-- Total Ordered -->
              <div class="col-md-4">
                <div class="bg-card-primary bg-opacity-10 rounded-0 p-3 h-100">
                  <div class="d-flex align-items-center justify-content-between mb-2">
                    <span class="text-muted">Total Ordered</span>
                    <i class="bi bi-cart-plus text-primary fs-5"></i>
                  </div>
                  <div class="d-flex align-items-baseline gap-1">
                    <h3 class="fw-bold mb-0 text-primary">{{ order.total_boxes_ordered }}</h3>
                    <span class="text-muted">boxes</span>
                  </div>
                </div>
              </div>

              <!-- Total Shipped -->
              <div class="col-md-4">
                <div class="bg-warning bg-opacity-10 rounded-0 p-3 h-100">
                  <div class="d-flex align-items-center justify-content-between mb-2">
                    <span class="text-muted">Total Shipped</span>
                    <i class="bi bi-truck text-warning fs-5"></i>
                  </div>
                  <div class="d-flex align-items-baseline gap-1">
                    <h3 class="fw-bold mb-0 text-warning">{{ order.total_boxes_shipped }}</h3>
                    <span class="text-muted">boxes</span>
                  </div>
                  <div class="progress mt-2" style="height: 4px">
                    <div
                      class="progress-bar bg-warning"
                      role="progressbar"
                      [style.width.%]="(order.total_boxes_shipped / order.total_boxes_ordered) * 100"
                      [attr.aria-valuenow]="order.total_boxes_shipped"
                      [attr.aria-valuemin]="0"
                      [attr.aria-valuemax]="order.total_boxes_ordered"></div>
                  </div>
                </div>
              </div>

              <!-- Total Delivered -->
              <div class="col-md-4">
                <div class="bg-success bg-opacity-10 rounded-0 p-3 h-100">
                  <div class="d-flex align-items-center justify-content-between mb-2">
                    <span class="text-muted">Total Delivered</span>
                    <i class="bi bi-check-circle text-success fs-5"></i>
                  </div>
                  <div class="d-flex align-items-baseline gap-1">
                    <h3 class="fw-bold mb-0 text-success">{{ order.total_boxes_delivered }}</h3>
                    <span class="text-muted">boxes</span>
                  </div>
                  <div class="progress mt-2" style="height: 4px">
                    <div
                      class="progress-bar bg-success"
                      role="progressbar"
                      [style.width.%]="(order.total_boxes_delivered / order.total_boxes_ordered) * 100"
                      [attr.aria-valuenow]="order.total_boxes_delivered"
                      [attr.aria-valuemin]="0"
                      [attr.aria-valuemax]="order.total_boxes_ordered"></div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Optional: Completion Status Bar -->
            <div class="mt-4 pt-3 border-top">
              <div class="d-flex justify-content-between align-items-center mb-2">
                <span class="text-muted">Completion Status</span>
                <span class="text-muted">
                  {{ order.total_boxes_delivered }}/{{ order.total_boxes_ordered }} boxes delivered
                </span>
              </div>
              <div class="progress" style="height: 8px">
                <div
                  class="progress-bar bg-success"
                  role="progressbar"
                  [style.width.%]="(order.total_boxes_delivered / order.total_boxes_ordered) * 100"></div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Ordered Items -->
      <div class="col-12 px-0 mb-4">
        <div class="card border-0 p-0">
          <div class="card-header bg-white border-bottom d-flex justify-content-between align-items-center">
            <span>Ordered Items</span>
            @if (!order.is_fully_shipped && !order.is_order_cancelled) {
              <button class="btn btn-primary btn-sm" (click)="openShipModal()">
                <i class="bi bi-truck me-1"></i>
                Create Shipment
              </button>
            }
          </div>

          <div class="card-body p-3">
            <div class="table-responsive">
              <table class="table table-hover align-middle mb-0">
                <thead class="text-muted">
                  <tr>
                    <th>Product</th>
                    <th class="text-end">Ordered (Box)</th>
                    <th class="text-end">Nos</th>
                    <th class="text-end">Shipped</th>
                    <th class="text-end">Pending</th>
                    <th class="text-end">Status</th>
                    <th class="text-end">Action</th>
                  </tr>
                </thead>

                <tbody>
                  <tr
                    *ngFor="let item of order.items"
                    [class.opacity-50]="item.pending_quantity === 0 && item.status !== OrderItemStatus.CANCELLED">
                    <td>
                      <div class="fw-medium">{{ getProductTitle(item) }}</div>
                      <span class="text-muted">{{ getPackagingLabel(item) }}</span>
                    </td>

                    <td class="text-end">{{ item.box_quantity }}</td>
                    <td class="text-end">{{ item.box_quantity * item.product_packaging.nos }}</td>
                    <td class="text-end">{{ item.shipped_quantity }}</td>
                    <td class="text-end">{{ item.pending_quantity }}</td>

                    <td class="text-end">
                      <span
                        class="app-badge"
                        [class.badge-danger]="item.status === OrderItemStatus.CANCELLED"
                        [class.badge-success]="item.status !== OrderItemStatus.CANCELLED && item.pending_quantity === 0"
                        [class.badge-warning]="
                          item.status !== OrderItemStatus.CANCELLED &&
                          item.shipped_quantity > 0 &&
                          item.pending_quantity > 0
                        "
                        [class.badge-secondary]="
                          item.status !== OrderItemStatus.CANCELLED && item.shipped_quantity === 0
                        ">
                        {{ item.status | titlecase }}
                      </span>
                    </td>

                    <td class="text-end">
                      @if (item.pending_quantity > 0 && item.status !== OrderItemStatus.CANCELLED) {
                        <button
                          class="btn btn-danger btn-sm"
                          [disabled]="cancellingItemId === item.id"
                          (click)="cancelItem(item)">
                          @if (cancellingItemId === item.id) {
                            <app-loading-spinner [inline]="true" [textClass]="'text-white'" />
                          } @else {
                            <i class="bi bi-x-circle me-1"></i>
                          }
                          Cancel
                        </button>
                      } @else if (item.pending_quantity === 0) {
                        <span class="text-success fw-medium small">Fulfilled</span>
                      }
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>

      <!-- Shipments -->
      <div class="col-12 px-0 mb-4">
        <div class="card border-0 p-0">
          <div class="card-header bg-white border-bottom fw-bold">
            Shipments
            <span class="badge bg-secondary ms-2">{{ order.shipments?.length || 0 }}</span>
          </div>
          <div class="card-body p-3">
            @if (!order.shipments?.length) {
              <p class="text-muted mb-0">No shipments created yet. Ship items above to create a shipment.</p>
            } @else {
              <div class="d-flex flex-column gap-3">
                @for (shipment of order.shipments; track shipment.id) {
                  <div class="border rounded p-3">
                    <!-- Shipment header -->
                    <div class="d-flex flex-wrap justify-content-between align-items-start gap-2 mb-3">
                      <div>
                        <span class="fw-bold">#{{ shipment.shipment_number }}</span>
                        <span
                          class="app-badge ms-2"
                          [ngClass]="{
                            'badge-secondary': shipment.status === ShipmentStatus.PENDING,
                            'badge-warning':
                              shipment.status === ShipmentStatus.PACKED ||
                              shipment.status === ShipmentStatus.IN_TRANSIT,
                            'badge-primary': shipment.status === ShipmentStatus.DISPATCHED,
                            'badge-success': shipment.status === ShipmentStatus.DELIVERED,
                            'badge-danger': shipment.status === ShipmentStatus.CANCELLED,
                          }">
                          {{ shipment.status | titlecase }}
                        </span>
                      </div>

                      <!-- Action buttons -->
                      <div class="d-flex gap-2 flex-wrap">
                        @if (canAssignTransporter(shipment)) {
                          <button class="btn btn-sm btn-soft-primary" (click)="openAssignTransporterModal(shipment)">
                            <i class="bi bi-person-badge"></i>
                            {{ shipment.transporter ? 'Change Transporter' : 'Assign Transporter' }}
                          </button>
                        }
                        @if (canMarkDispatched(shipment)) {
                          <button class="btn btn-sm btn-soft-primary" (click)="openMarkDispatchedModal(shipment)">
                            <i class="bi bi-truck"></i>
                            Mark Dispatched
                          </button>
                        }
                        @if (canMarkDelivered(shipment)) {
                          <button class="btn btn-sm btn-soft-primary" (click)="openMarkDeliveredModal(shipment)">
                            <i class="bi bi-check2-circle me-1"></i>
                            Mark Delivered
                          </button>
                        }
                      </div>
                    </div>

                    <!-- Shipment meta -->
                    <div class="row g-3 mb-3">
                      <div class="col-sm-4">
                        <small class="text-uppercase fw-bold text-muted">Transporter</small>
                        @if (shipment.transporter) {
                          <div class="mt-1">
                            <i class="bi bi-truck text-muted me-1"></i>
                            {{ shipment.transporter.first_name }} {{ shipment.transporter.last_name }}
                          </div>
                          <small class="text-muted">{{ shipment.transporter.vehicle_number }}</small>
                        } @else {
                          <div class="mt-1 text-muted small">Not assigned</div>
                        }
                      </div>
                      <div class="col-sm-4">
                        <small class="text-uppercase fw-bold text-muted">Dispatch Date</small>
                        <div class="mt-1">
                          {{ shipment.dispatch_date ? (shipment.dispatch_date | date: 'dd MMM yyyy') : '—' }}
                        </div>
                      </div>
                      <div class="col-sm-4">
                        <small class="text-uppercase fw-bold text-muted">
                          {{ shipment.status === ShipmentStatus.DELIVERED ? 'Delivery Date' : 'Expected Delivery' }}
                        </small>
                        <div class="mt-1">
                          {{ shipment.delivery_date ? (shipment.delivery_date | date: 'dd MMM yyyy') : '—' }}
                        </div>
                      </div>
                    </div>

                    <!-- Shipment items -->
                    @if (shipment.items?.length) {
                      <div class="table-responsive">
                        <table class="table table-sm align-middle mb-0">
                          <thead class="bg-light">
                            <tr>
                              <th class="border-0 text-uppercase small fw-bold text-muted">Product</th>
                              <th class="border-0 text-uppercase small fw-bold text-muted text-end">Boxes</th>
                            </tr>
                          </thead>
                          <tbody>
                            @for (si of shipment.items; track si.id) {
                              <tr>
                                <td class="small">
                                  {{ getProductTitle(si.order_item) }}
                                  <span class="text-muted ms-1">({{ getPackagingLabel(si.order_item) }})</span>
                                </td>
                                <td class="text-end small fw-semibold">{{ si.box_quantity }}</td>
                              </tr>
                            }
                          </tbody>
                        </table>
                      </div>
                    }
                  </div>
                }
              </div>
            }
          </div>
        </div>
      </div>
    </div>
  } @else {
    <app-info-alert>{{ NO_ORDER_DETAILS_FOUND_ALERT_MSG }}</app-info-alert>
  }
}

<!-- Ship Modal -->
<ng-template #shipModal let-modal>
  <div class="modal-header py-3">
    <h5 class="modal-title fw-bold">Create Shipment</h5>
    <button type="button" class="btn-close" [disabled]="isShipping" (click)="modal.dismiss()"></button>
  </div>

  <div class="modal-body p-0">
    <div class="p-4 pb-0">
      <div class="alert alert-info d-flex align-items-start mb-0" role="alert">
        <i class="bi bi-info-circle-fill me-2 mt-1"></i>
        <div>
          <strong>Two ways to finish here.</strong>
          <span class="fw-semibold">Confirm Shipment</span>
          creates the shipment as pending, and you assign a transporter and dispatch it later from the order.
          <span class="fw-semibold">Create &amp; Dispatch</span>
          does both at once: pick a transporter and an expected delivery date below and the goods leave as dispatched.
          Either way, pick a batch for every item you are sending.
        </div>
      </div>
    </div>

    <!-- Per-item batch selection -->
    @for (config of shipItemConfigs; track config.item.id) {
      <div class="p-4 border-bottom">
        <!-- Item header -->
        <div class="d-flex justify-content-between align-items-start mb-3">
          <div>
            <div class="fw-semibold">{{ getProductTitle(config.item) }}</div>
            <div class="text-muted small">{{ getPackagingLabel(config.item) }}</div>
          </div>
          <div class="d-flex gap-3 text-end small text-muted">
            <div>
              <div class="fw-bold text-dark">{{ config.item.box_quantity }}</div>
              <div>ordered</div>
            </div>
            <div>
              <div class="fw-bold text-warning">{{ config.item.shipped_quantity }}</div>
              <div>shipped</div>
            </div>
            <div>
              <div class="fw-bold text-primary">{{ config.item.pending_quantity }}</div>
              <div>pending</div>
            </div>
          </div>
        </div>

        <!-- Batch selection -->
        @if (config.isLoadingBatches) {
          <div class="text-muted small py-2">
            <span class="spinner-border spinner-border-sm me-2"></span>
            Loading available stock...
          </div>
        } @else if (config.batchStocks.length === 0) {
          <div class="alert alert-warning py-2 px-3 small mb-3">
            <i class="bi bi-exclamation-triangle me-1"></i>
            No warehouse stock available for this product.
          </div>
        } @else {
          <div class="table-responsive border rounded mb-3">
            <table class="table table-sm table-hover mb-0">
              <thead class="bg-light">
                <tr>
                  <th class="border-0 small fw-bold text-muted ps-3 py-2">Select</th>
                  <th class="border-0 small fw-bold text-muted py-2">Batch</th>
                  <th class="border-0 small fw-bold text-muted py-2">MFG Date</th>
                  <th class="border-0 small fw-bold text-muted py-2">EXP Date</th>
                  <th class="border-0 small fw-bold text-muted py-2">Warehouse</th>
                  <th class="border-0 small fw-bold text-muted py-2 text-end pe-3">Available</th>
                </tr>
              </thead>
              <tbody>
                @for (batch of config.batchStocks; track batch.id) {
                  <tr
                    [class.table-primary]="config.selectedBatch?.id === batch.id"
                    style="cursor: pointer"
                    (click)="selectBatch(config, batch)">
                    <td class="ps-3 py-2">
                      <input type="radio" class="form-check-input" [checked]="config.selectedBatch?.id === batch.id" />
                    </td>
                    <td class="py-2 fw-semibold font-monospace small">{{ batch.batch_number }}</td>
                    <td class="py-2 text-muted small">
                      {{ batch.manufacturing_date ? (batch.manufacturing_date | date: 'dd MMM yyyy') : '—' }}
                    </td>
                    <td class="py-2 text-muted small">
                      {{ batch.expiry_date ? (batch.expiry_date | date: 'dd MMM yyyy') : '—' }}
                    </td>
                    <td class="py-2 small">{{ batch.warehouse_name }}</td>
                    <td class="py-2 text-end pe-3">
                      <span class="fw-bold font-monospace">{{ batch.boxes_available }} boxes</span>
                      <div class="text-muted small font-monospace">({{ batch.units_available }} units)</div>
                    </td>
                  </tr>
                }
              </tbody>
            </table>
          </div>
        }

        <!-- Quantity input (shown only when a batch is selected) -->
        @if (config.selectedBatch) {
          <div class="d-flex align-items-center gap-3">
            <div style="width: 180px">
              <label class="form-label small fw-bold text-muted mb-1">Boxes to Ship</label>
              <input
                type="number"
                class="form-control"
                [(ngModel)]="config.box_quantity"
                min="1"
                [max]="Math.min(config.item.pending_quantity, +config.selectedBatch.boxes_available)"
                [disabled]="config.isShipping" />
              <div class="text-muted small mt-1">
                Max: {{ Math.min(config.item.pending_quantity, +config.selectedBatch.boxes_available) }} boxes
              </div>
            </div>
            <div class="small text-muted mt-3">
              from
              <span class="fw-semibold text-dark">{{ config.selectedBatch.batch_number }}</span>
              {{ config.selectedBatch.warehouse_name }}
            </div>
          </div>
        }

        <!-- Per-item error -->
        @if (config.error) {
          <div class="alert alert-danger py-2 px-3 small mt-2 mb-0">
            <i class="bi bi-exclamation-circle me-1"></i>
            {{ config.error }}
          </div>
        }

        <!-- Shipping spinner for this item -->
        @if (config.isShipping) {
          <div class="text-muted small mt-2">
            <span class="spinner-border spinner-border-sm me-1"></span>
            Shipping...
          </div>
        }
      </div>
    }

    <!-- Transporter -->
    <div class="p-4 border-bottom">
      <div class="fw-semibold mb-3">
        Transporter
        <span class="text-muted fw-normal small ms-1">(optional)</span>
      </div>
      @if (isTransportersLoading) {
        <div class="text-muted small">
          <span class="spinner-border spinner-border-sm me-1"></span>
          Loading transporters...
        </div>
      } @else {
        <!-- Appended to body: this modal is scrollable, and its overflow-y would -->
        <!-- otherwise cut the panel off at the footer. -->
        <ng-select
          [items]="transporters"
          [(ngModel)]="shipTransporterId"
          bindValue="id"
          appendTo="body"
          placeholder="Select transporter..."
          [disabled]="isShipping">
          <ng-template ng-label-tmp let-item="item">
            {{ item.first_name }} {{ item.last_name }} — {{ item.vehicle_number }}
          </ng-template>
          <ng-template ng-option-tmp let-item="item">
            <div class="fw-semibold">{{ item.first_name }} {{ item.last_name }}</div>
            <small class="text-muted">{{ item.vehicle_number }} · {{ item.phone_number }}</small>
          </ng-template>
        </ng-select>
      }

      <div class="row g-3 mt-1">
        <div class="col-md-6">
          <label class="form-label small fw-bold text-muted">
            Expected Delivery Date
            <span class="text-muted fw-normal">(to dispatch now)</span>
          </label>
          <input type="date" class="form-control" [(ngModel)]="shipExpectedDeliveryDate" [disabled]="isShipping" />
          <div class="form-text">
            Fill this in with a transporter to create and dispatch in one step. Leave it blank to create the shipment as
            pending and dispatch later.
          </div>
        </div>
      </div>
    </div>

    <!-- Optional fields -->
    <div class="p-4">
      <button
        type="button"
        class="btn btn-link p-0 text-decoration-none text-muted small fw-semibold"
        (click)="showOptionalFields = !showOptionalFields">
        <i class="bi me-1" [class.bi-chevron-down]="!showOptionalFields" [class.bi-chevron-up]="showOptionalFields"></i>
        {{ showOptionalFields ? 'Hide' : 'Show' }} additional fields
      </button>

      @if (showOptionalFields) {
        <div class="row g-3 mt-1">
          <div class="col-md-4">
            <label class="form-label small fw-bold text-muted">Dispatch Date</label>
            <input type="date" class="form-control" [(ngModel)]="shipDispatchDate" [disabled]="isShipping" />
          </div>
          <div class="col-md-4">
            <label class="form-label small fw-bold text-muted">Tracking Number</label>
            <input
              type="text"
              class="form-control"
              [(ngModel)]="shipTrackingNumber"
              placeholder="e.g. TRK123"
              [disabled]="isShipping" />
          </div>
          <div class="col-12">
            <label class="form-label small fw-bold text-muted">Remarks</label>
            <textarea
              class="form-control"
              rows="2"
              [(ngModel)]="shipRemarks"
              placeholder="e.g. Handle with care"
              [disabled]="isShipping"></textarea>
          </div>
        </div>
      }
    </div>
  </div>

  <div class="modal-footer d-flex justify-content-between align-items-center py-3">
    <!-- Summary -->
    <span class="text-muted small">
      @if (configuredItemsCount > 0) {
        Shipping
        <strong>{{ configuredItemsCount }} item{{ configuredItemsCount !== 1 ? 's' : '' }}</strong>
        across
        <strong>{{ uniqueBatchesCount }} batch{{ uniqueBatchesCount !== 1 ? 'es' : '' }}</strong>
      } @else {
        Select a batch for at least one item to proceed.
      }
    </span>

    <div class="d-flex align-items-center gap-2">
      @if (dispatchBlockedReason) {
        <span class="text-muted small">{{ dispatchBlockedReason }}</span>
      }

      <button class="btn btn-secondary" [disabled]="isShipping" (click)="modal.dismiss()">Cancel</button>
      <button
        class="btn btn-outline-primary"
        [disabled]="configuredItemsCount === 0 || isShipping"
        (click)="confirmShipment()">
        @if (isShipping) {
          <span class="spinner-border spinner-border-sm me-1"></span>
          Shipping...
        } @else {
          <i class="bi bi-box-seam me-1"></i>
          Confirm Shipment
        }
      </button>

      <button class="btn btn-primary" [disabled]="!canCreateAndDispatch" (click)="confirmShipment(true)">
        @if (isShipping) {
          <span class="spinner-border spinner-border-sm me-1"></span>
          Shipping...
        } @else {
          <i class="bi bi-truck me-1"></i>
          Create &amp; Dispatch
        }
      </button>
    </div>
  </div>
</ng-template>

<!-- Assign Transporter Modal -->
<ng-template #assignTransporterModal let-modal>
  <div class="modal-header">
    <h5 class="modal-title">Assign Transporter</h5>
    <button type="button" class="btn-close" (click)="modal.dismiss()"></button>
  </div>
  <div class="modal-body">
    <p class="text-muted small mb-3">
      Shipment
      <strong>#{{ activeShipment?.shipment_number }}</strong>
    </p>
    @if (isTransportersLoading) {
      <app-loading-spinner [message]="'Loading transporters...'" />
    } @else {
      <label class="form-label fw-bold small">Select Transporter</label>
      <ng-select
        [items]="transporters"
        [(ngModel)]="selectedTransporterId"
        bindValue="id"
        placeholder="Search transporter...">
        <ng-template ng-label-tmp let-item="item">
          {{ item.first_name }} {{ item.last_name }} — {{ item.vehicle_number }}
        </ng-template>
        <ng-template ng-option-tmp let-item="item">
          <div class="fw-semibold">{{ item.first_name }} {{ item.last_name }}</div>
          <small class="text-muted">{{ item.vehicle_number }} · {{ item.phone_number }}</small>
        </ng-template>
      </ng-select>
    }
  </div>
  <div class="modal-footer border-0">
    <button class="btn btn-secondary" (click)="modal.dismiss()">Cancel</button>
    <button
      class="btn btn-primary"
      [disabled]="!selectedTransporterId || isActionLoading"
      (click)="confirmAssignTransporter()">
      @if (isActionLoading) {
        <span class="spinner-border spinner-border-sm me-1"></span>
      }
      Assign
    </button>
  </div>
</ng-template>

<!-- Mark Dispatched Modal -->
<ng-template #markDispatchedModal let-modal>
  <div class="modal-header">
    <h5 class="modal-title">Mark as Dispatched</h5>
    <button type="button" class="btn-close" (click)="modal.dismiss()"></button>
  </div>
  <div class="modal-body">
    <p class="text-muted small mb-3">
      Shipment
      <strong>#{{ activeShipment?.shipment_number }}</strong>
    </p>
    <label class="form-label fw-bold small">
      Expected Delivery Date
      <span class="text-danger">*</span>
    </label>
    <input type="date" class="form-control" [(ngModel)]="expectedDeliveryDate" [min]="today" />
  </div>
  <div class="modal-footer border-0">
    <button class="btn btn-secondary" (click)="modal.dismiss()">Cancel</button>
    <button
      class="btn btn-primary"
      [disabled]="!expectedDeliveryDate || isActionLoading"
      (click)="confirmMarkDispatched()">
      @if (isActionLoading) {
        <span class="spinner-border spinner-border-sm me-1"></span>
      }
      <i class="bi bi-truck me-1"></i>
      Confirm Dispatch
    </button>
  </div>
</ng-template>

<!-- Mark Delivered Modal -->
<ng-template #markDeliveredModal let-modal>
  <div class="modal-header">
    <h5 class="modal-title">Mark as Delivered</h5>
    <button type="button" class="btn-close" (click)="modal.dismiss()"></button>
  </div>
  <div class="modal-body">
    <p class="text-muted small mb-3">
      Shipment
      <strong>#{{ activeShipment?.shipment_number }}</strong>
    </p>
    <label class="form-label fw-bold small">
      Actual Delivery Date
      <span class="text-danger">*</span>
    </label>
    <input type="date" class="form-control" [(ngModel)]="deliveryDate" [max]="today" />
  </div>
  <div class="modal-footer border-0">
    <button class="btn btn-secondary" (click)="modal.dismiss()">Cancel</button>
    <button class="btn btn-primary" [disabled]="!deliveryDate || isActionLoading" (click)="confirmMarkDelivered()">
      @if (isActionLoading) {
        <span class="spinner-border spinner-border-sm me-1"></span>
      }
      <i class="bi bi-check2-circle me-1"></i>
      Confirm Delivery
    </button>
  </div>
</ng-template>
